"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.ai.title': 'Preguntar al asistente IA',
    'socialMediaPlan.ai.desc': 'El asistente analiza tu biblioteca.',
    'socialMediaPlan.ai.preset.topics': '¿Qué temas generarán más interacción?',
    'socialMediaPlan.ai.preset.plan': 'Plan de contenido para la próxima semana',
    'socialMediaPlan.ai.preset.timing': '¿Cuándo publicar?',
    'socialMediaPlan.ai.preset.summary': 'Resumen mensual',
    'socialMediaPlan.ai.placeholder': 'Pregunta p.ej. 3 ideas para Instagram...',
    'socialMediaPlan.ai.ask': 'Preguntar IA',
    'socialMediaPlan.ai.error': 'Error del asistente IA.',
};
